import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from "./components/ScrollToTop";
import FloatingUniqueButtons from "./components/FloatingButtons";
import FloatingForm from './components/FloatingForm.js';
import TawkToWidget from './components/TawkToWidget';
import ProtectedRoute from './components/ProtectedRoute';
import SeoManager from './seo/SeoManager';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Courses from './pages/Courses';
import Alumni from './pages/Alumni';
import Partner from './pages/Partner';
import Blogs from './pages/Blogs';
import Events from './pages/Events';
import Contact from './pages/Contact';
import Awards from './pages/Awards';
import Competition from './pages/Competition';
import NttCourse from './pages/nttcourse';
import Admission from './pages/admission';
import Result from './pages/Result';
import Pttcourse from './pages/Pttcourse';
import TermsAndConditions from './pages/terms-conditions';
import Privacypolicy from './pages/privacypolicy';
import Refundpolicy from './pages/refund-policy';
import BlogDetails from "./pages/BlogDetails";
import EventDetails from "./pages/EventDetails";

import Login from './pages/Login';
import Signup from './pages/Signup';
import AdmissionForm from './components/Addmission/AdmissionForm.jsx';
import AdmissionProcess from './components/Addmission/AdmissionProcess';

import AdminDashboard from './pages/admin/AdminDashboard.js';
import TeacherDashboard from './pages/teacher/TeacherDashboard';
import StudentDashboard from './pages/student/StudentDashboard.js';

// Context
import { AuthProvider } from './context/AuthContext';

import './App.css'


// ===== Layout Wrapper =====
function Layout({ children }) {
  const location = useLocation();

  // Routes where floating buttons must be hidden
  const hideFloatingRoutes = ["/admin", "/teacher", "/student"];

  const shouldHideFloating = hideFloatingRoutes.some(path =>
    location.pathname.startsWith(path)
  );

  return (
    <>
      {/* <TawkToWidget /> */}
      <SeoManager />
      <ScrollToTop />
      <Header />

      {children}

      <Footer />

      {/* Floating elements only on public pages */}
      {!shouldHideFloating && (
        <>
          <FloatingForm />
          <FloatingUniqueButtons />
        </>
      )}

      <ToastContainer />
    </>
  );
}


// ===== Main App =====
const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Layout>
          <Routes>

            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/alumni" element={<Alumni />} />
            <Route path="/partner" element={<Partner />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/events" element={<Events />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/course/ptt-course" element={<Pttcourse />} />
            <Route path="/course/results" element={<Result />} />
            <Route path="/course/admission" element={<Admission />} />
            <Route path="/competitions" element={<Competition />} />
            <Route path="/course/ntt-mttcourse" element={<NttCourse />} />
            <Route path="/terms-conditions" element={<TermsAndConditions />} />
            <Route path="/privacypolicy" element={<Privacypolicy />} />
            <Route path="/refund-policy" element={<Refundpolicy />} />
            <Route path="/post/:slug" element={<BlogDetails />} />
            <Route path="/events/:slug" element={<EventDetails />} />

            {/* Auth Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/apply" element={<AdmissionForm headingLevel="h1" />} />
            <Route path="/admission-process" element={<AdmissionProcess headingLevel="h1" />} />

            {/* Protected Dashboards */}
            <Route path="/admin/*" element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminDashboard />
              </ProtectedRoute>
            } />

            <Route path="/teacher/*" element={
              <ProtectedRoute allowedRoles={['teacher']}>
                <TeacherDashboard />
              </ProtectedRoute>
            } />

            <Route path="/student/*" element={
              <ProtectedRoute allowedRoles={['student']}>
                <StudentDashboard />
              </ProtectedRoute>
            } />

          </Routes>
        </Layout>
      </Router>
    </AuthProvider>
  );
};

export default App;
